export type User = {
  id: number;
  firebaseUid: string;
  name?: string;
  email?: string;
  password?: string;
  phone: string;
  role: string;
  authCode?: string;
  createdAt?: string;
  updatedAt?: string;
  suspended: boolean;
  phoneVerified: boolean;
  emailVerified: boolean;
  gender?: string;
  assistanceRequired?: string;
  fcmToken?: string;
  appType?: string;
  homeCity?: string;
  currentCity?: string;
  // Android versionCode reported on register-fcm-token. null = build predates version reporting.
  appVersion?: number | null;       // legacy shared column — do NOT display, last-writer-wins
  driverAppVersion?: number | null; // what the location_ping gate reads
  riderAppVersion?: number | null;
  // Stamped by the same call, so it doubles as "when we last heard from this app version".
  fcmTokenUpdatedAt?: string | null;
};

export const booleanFields = ["suspended", "phoneVerified", "emailVerified"] as const;
export const editableFields = ["name", "email", "phone", "authCode", "gender", "assistanceRequired"] as const;
